import { isRequestError } from 'utils/requestError';
import { ModalPinCode } from 'components';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useCheckPinCodeMutation } from 'services';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: ({ pinCode }: { pinCode: string }) => void;
};

const ModalConfirm = (props: Props) => {
  const { isOpen, onSuccess, onClose } = props;

  const [isShowPopup, setIsShowPopup] = useState<boolean>(isOpen);

  const { mutateAsync, isLoading } = useCheckPinCodeMutation();

  useEffect(() => {
    setIsShowPopup(isOpen);

    return () => setIsShowPopup(false);
  }, [isOpen]);

  const handleCheckPinCode = async (pinCode: string) => {
    try {
      const dataCheckPinCode = await mutateAsync({ pinCode });

      if (dataCheckPinCode && dataCheckPinCode?.isValid) {
        // toast.success("Xác thực thành công");

        return onSuccess({ pinCode });
      }

      throw dataCheckPinCode;
    } catch (error: any) {
      console.error(error);
      if (!isRequestError(error)) {
        toast.error(String(error?.message) || 'Xác thực không thành công');
      }
    }
  };

  return (
    <ModalPinCode
      isOpen={isShowPopup}
      isLoading={isLoading}
      onConfirm={handleCheckPinCode}
      onClose={() => {
        setIsShowPopup(false);
        onClose();
      }}
    />
  );
};

export default ModalConfirm;
